import { render, staticRenderFns } from "./Promise.vue?vue&type=template&id=0a186f05"
import script from "./Promise.vue?vue&type=script&lang=js"
export * from "./Promise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports